import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { RowItems } from '../../models/TableProps';
import { ShipmentsData } from 'models/Shipments';

export const ShipmentLabelDetailsTableRow: React.FC<RowItems<ShipmentsData>> = (
    props
) => {
    const { row, index } = props;
    const { t } = useTranslation('invoices');
    const labelId = `enhanced-table-checkbox-${index}`;

    return (
        <TableRow hover>
            <TableCell component="th" id={labelId} scope="row">
                {row.number}
            </TableCell>
            <TableCell>{row.customerName}</TableCell>
            <TableCell>{row.invoiceDate}</TableCell>
            <TableCell>{row.orderNumber}</TableCell>
        </TableRow>
    );
};
